var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.srcset)?_c('img',{staticClass:"ImgLazy",attrs:{"data-srcset":_vm.srcset,"data-src":_vm.src,"alt":_vm.alt}}):_c('img',{staticClass:"ImgLazy",attrs:{"data-src":_vm.src,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }